module.exports = { id: "cross", url: "/build/app/img/symbols.svg#cross", viewBox: "", toString: function() { return this.url; } };